"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Alert_1 = __importDefault(require("react-bootstrap/Alert"));
require("./alert.scss");
function Alert(props) {
    return (react_1.default.createElement(Alert_1.default, { className: "mpng-ux-alert",
        variant: props.priority,
        onClose: props.handleClose,
        dismissible: props.dismissible },
        props.heading && react_1.default.createElement(Alert_1.default.Heading, null, props.heading),
        props.body && react_1.default.createElement("p", null, props.body)));
}
exports.default = Alert;
